import { apiSlice } from '../app/api/apiSlice';
import { setDelyveryMethods } from '../store/slices/swarms';

export const jobSLookUpTablesApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    jobStatus: builder.query({
      query: () => 'Jobs/jobstatus',
      keepUnusedDataFor: 40,
      providesTags: (result, error, arg)=>[
        {type:'jobStatus', id: 'LIST'},
      ]
    }),
    jobPriority: builder.query({
      query: () => 'Jobs/jobPrioritys',
      keepUnusedDataFor: 40,
      providesTags: (result, error, arg)=>[
        {type:'jobPrioritys', id: 'LIST'},
      ]
    }),
    jobTypes: builder.query({
      query: () => 'Jobs/jobTypes',
      keepUnusedDataFor: 40,
      providesTags: (result, error, arg)=>[
        {type:'jobTypes', id: 'LIST'},
      ]
    }),
    deliveryMethods: builder.query({
      query: () => 'Purchases/deliveryMethods',
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        // `onStart` side-effect
        console.log('deliveryMethods side-Effect, start...')
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('deliveryMethods side-Effect, success: ', data)
          dispatch(setDelyveryMethods(data))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('deliveryMethods side-Effect, error: ', err)
          throw err
        }
      },
      keepUnusedDataFor: 200,
      providesTags: (result, error, arg)=>[
        {type:'deliveryMethods', id: 'LIST'},
      ]
    }),

  })
})

export const { useJobStatusQuery, useJobPriorityQuery, useJobTypesQuery, useDeliveryMethodsQuery} = jobSLookUpTablesApi;
